// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"40bbb299","348":"42e019aa","546":"c061c4d2","558":"196c70e9","571":"0fa98f73"}[chunkId] + ".chunk.js";
};